import { render, staticRenderFns } from "./HandleModal.vue?vue&type=template&id=3f95a20c&scoped=true"
import script from "./HandleModal.vue?vue&type=script&setup=true&lang=js"
export * from "./HandleModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./HandleModal.vue?vue&type=style&index=0&id=3f95a20c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f95a20c",
  null
  
)

export default component.exports